<template>
    <AppHeaderDropdown>
        <template slot="header">
            <span class="active">Talk</span>
        </template>
        <template slot="dropdown">
            <b-dropdown-item
                to="/v2/feedbacks/templates"
                v-if="hasTalk && (isAdmin || isValuesMaster || isGod)"
            >
                {{ $t('talk.templates') }}
            </b-dropdown-item>
            <b-dropdown-item to="/v2/feedbacks/list">
                {{ $t('talk.feedbacks') }}
            </b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'

export default {
    name: 'DefaultTalkDropdown',
    props: ['isAdmin', 'hasTalk', 'isValuesMaster', 'isGod'],
    components: {
        AppHeaderDropdown,
    },
}
</script>
